// USED IN FLEXIBLE COLUMN CONTAINER BLOCK, EXTENDED SEARCH BLOCK

import Swiper from "swiper";
import { Navigation } from "swiper/modules";

import "swiper/css";

export default function HorizontalStickySubnavCarousel() {
  const swiperElement = document.querySelectorAll<HTMLDivElement>(".js-horizontal-sticky-nav");

  if (swiperElement && swiperElement.length > 0) {
    Swiper.use([Navigation]);

    swiperElement.forEach((el: HTMLDivElement) => {
      if (el) {
        const wrapper = el.querySelector<HTMLDivElement>(".js-wrapper");
        const carouselEl = el.querySelector<HTMLDivElement>(".swiper");
        const slides = el.querySelectorAll<HTMLDivElement>(".swiper-slide");
        const nextBtn = el.querySelector<HTMLButtonElement>(".swiper-btn-next");
        const prevBtn = el.querySelector<HTMLButtonElement>(".swiper-btn-prev");

        const handleTotalWidth = () => {
          let totalWidth = 0;

          if (slides && slides.length > 0) {
            slides.forEach((slide) => {
              totalWidth += slide.offsetWidth;
            });
          }

          return totalWidth;
        };

        const handleShowNavigation = () => {
          const wrapperWidth = wrapper?.offsetWidth || 0;

          if (handleTotalWidth() > wrapperWidth) {
            el.setAttribute("data-show-nav", "true");
          } else {
            el.setAttribute("data-show-nav", "false");
          }
        };

        if (carouselEl) {
          new Swiper(carouselEl, {
            slidesPerView: "auto",
            navigation: {
              nextEl: nextBtn,
              prevEl: prevBtn,
            },
          });
        }

        handleShowNavigation();
        window.addEventListener("resize", handleShowNavigation);
      }
    });
  }
}
